// Useful for logging in or out, before we know the customer
const getStorageInUse = () => global.sessionStorage.getItem('user') ? global.sessionStorage : global.localStorage;

// Look at the user returned from the server to determine which storage to use
const getStorage = user => {
  const {
    sessionPersistence
  } = user || {};
  if (!sessionPersistence) {
    return global.sessionStorage;
  }
  return global.localStorage;
};
export { getStorageInUse, getStorage };